const LA_POSTE = "356000000";

/** Keep digits only, capped at 9. A pasted SIRET (14 digits) yields its SIREN. */
export function cleanSiren(raw: string): string {
  return raw.replace(/\D/g, "").slice(0, 9);
}

export function isValidSiren(siren: string): boolean {
  if (!/^\d{9}$/.test(siren)) return false;
  if (siren === LA_POSTE) return true;
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let n = Number(siren[8 - i]);
    if (i % 2 === 1) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
  }
  return sum % 10 === 0;
}

export type SirenStatus = "empty" | "partial" | "invalid" | "valid";

export function sirenStatus(siren: string): SirenStatus {
  if (siren.length === 0) return "empty";
  if (siren.length < 9) return "partial";
  return isValidSiren(siren) ? "valid" : "invalid";
}

export function formatSiren(siren: string): string {
  return siren.replace(/^(\d{3})(\d{3})(\d{3})$/, "$1 $2 $3");
}
